import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';

import {AdditionalConfigValidationFunctions, ConfigValidationFunction} from '../StepConfigValidationTypes';

export const MISSING_IDENTIFIER_MESSAGE = 'Map an API ID column or a Registry ID column to update entities.';
export const BOTH_IDENTIFIERS_MESSAGE = 'Map either an API ID column or a Registry ID column, not both.';

interface IdentifierColumnMapping {
  id?: string | null;
  registryId?: string | null;
}

function isMappedColumn(value: string | null | undefined): boolean {
  return typeof value === 'string' && value !== '';
}

function identifierMapping(
  config: PipelineStepConfig<PipelineStepType.UPDATE_ENTITIES, 0>
): IdentifierColumnMapping | null {
  // PipelineJsonSpecToTsType does not model columnMapping, so the generated config type is `never`.
  const mapping = (config as {columnMapping?: IdentifierColumnMapping | null}).columnMapping;
  return mapping ?? null;
}

const validateConfig: ConfigValidationFunction<PipelineStepType.UPDATE_ENTITIES, 0> = (config) => {
  const columnMapping = identifierMapping(config);
  if (columnMapping == null) {
    return [];
  }
  const hasApiId = isMappedColumn(columnMapping.id);
  const hasRegistryId = isMappedColumn(columnMapping.registryId);
  if (hasApiId && hasRegistryId) {
    return [BOTH_IDENTIFIERS_MESSAGE];
  }
  if (!hasApiId && !hasRegistryId) {
    return [MISSING_IDENTIFIER_MESSAGE];
  }
  return [];
};

export default {
  stepType: PipelineStepType.UPDATE_ENTITIES,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.UPDATE_ENTITIES, 0>;
